<script setup>
import InputError from "@/Components/InputError.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";
import InputField from "@/Components/InputField.vue";
import InputLabel from "@/Components/InputLabel.vue";

import { defineProps, ref, computed, watch } from "vue";
import Swal from "sweetalert2";
import { useForm } from "@inertiajs/vue3";
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  jenis: {
    type: Object,
    required: true,
  },

  repository: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
  id: null,
  nama_dok: "",
  jenis_dok: "",
  status: "",
  deskripsi: "",
});

const handleFileUpload = (event) => {
  form.file_path = event.target.files[0] || "";
};
const fileInput = ref(null);

watch(
  () => props.repository,
  (newJenis) => {
    if (newJenis) {
      form.id = newJenis.id;
      form.iddok = newJenis.iddok;
      form.nama_dok = newJenis.nama_dok;
      form.jenis_dok = newJenis.jenis_dok;
      form.deskripsi = newJenis.deskripsi;
      form.status = newJenis.status;
    }
  },
  { immediate: true, deep: true }
);

const closeModal = () => {
  emit("update:isOpen", false);
};

const handleClickOutside = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

const submit = () => {
  form.put(route("documents.update", form.iddok), {
    onSuccess: () => {
      form.reset();
      closeModal();
    },
  });
};
</script>
<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black bg-opacity-50 sm:items-center sm:pt-0"
    @click="handleClickOutside"
  >
    <div
      class="relative w-full h-auto max-h-[90vh] p-4 overflow-y-auto bg-white rounded-lg sm:w-1/2 sm:p-6"
    >
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-xl font-bold">{{ title }}</h2>
        <button
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="closeModal"
          class="text-gray-500 transition duration-150 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <form class="space-y-6" @submit.prevent="submit">
        <div class="mt-4">
          <InputField label="Nama Dokumen" icon="pen" v-model="form.nama_dok" />
          <InputError :message="form.errors.nama_dok" class="mt-2" />
        </div>
        <div class="mt-4">
          <label for="Deskripsi">Deskripsi</label>
          <textarea
            class="w-full p-3 text-sm border-gray-200 rounded-lg"
            placeholder="Deskripsi"
            rows="5"
            v-model="form.deskripsi"
          ></textarea>
          <InputError :message="form.errors.deskripsi" />
        </div>

        <div class="mt-4">
          <label for="Prodi">Jenis</label>
          <select
            v-model="form.jenis_dok"
            class="block w-full px-3 py-2 text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">Pilih Jenis</option>
            <option v-for="jen in jenis" :key="jen.id" :value="jen.id">
              {{ jen.nama }}
            </option>
          </select>
          <InputError :message="form.errors.jenis_dok" class="mt-2" />
        </div>

        <div class="mt-4">
          <label for="Prodi">Kategori</label>
          <select
            v-model="form.status"
            class="block w-full px-3 py-2 text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">Pilih Kategori</option>
            <option value="0">Eksternal</option>
            <option value="1">Internal</option>
          </select>
          <InputError :message="form.errors.status" class="mt-2" />
        </div>

        <div class="mt-4">
          <PrimaryBtn :disabled="form.processing">
            <i class="fa-solid fa-floppy-disk"></i> Simpan
          </PrimaryBtn>
        </div>
      </form>
    </div>
  </div>
</template>
